export default __webpack_public_path__ + "static/media/payment-telekom.bfbfda4a.svg";